import {
  ADD_IDENTIFICATION,
  ADD_IDENTIFICATION_FAIL,
  ADD_IDENTIFICATION_SUCCESS,
  BUSINESS_UNIT_ACTIVE,
  BUSINESS_UNIT_ACTIVE_FAIL,
  BUSINESS_UNIT_ACTIVE_RESET,
  BUSINESS_UNIT_ACTIVE_SUCCESS,
  BUSINESS_UNIT_CONFIG_CREATE,
  BUSINESS_UNIT_CONFIG_CREATE_FAIL,
  BUSINESS_UNIT_CONFIG_CREATE_RESET,
  BUSINESS_UNIT_CONFIG_CREATE_SUCCESS,
  BUSINESS_UNIT_CONFIG_UPDATE,
  BUSINESS_UNIT_CONFIG_UPDATE_FAIL,
  BUSINESS_UNIT_CONFIG_UPDATE_RESET,
  BUSINESS_UNIT_CONFIG_UPDATE_SUCCESS,
  BUSINESS_UNIT_CREATE,
  BUSINESS_UNIT_CREATE_FAIL,
  BUSINESS_UNIT_CREATE_RESET,
  BUSINESS_UNIT_CREATE_SUCCESS,
  BUSINESS_UNIT_DELETE,
  BUSINESS_UNIT_DELETE_FAIL,
  BUSINESS_UNIT_DELETE_RESET,
  BUSINESS_UNIT_DELETE_SUCCESS,
  BUSINESS_UNIT_DETAIL,
  BUSINESS_UNIT_DETAIL_CONFIG,
  BUSINESS_UNIT_DETAIL_CONFIG_FAIL,
  BUSINESS_UNIT_DETAIL_CONFIG_RESET,
  BUSINESS_UNIT_DETAIL_CONFIG_SUCCESS,
  BUSINESS_UNIT_DETAIL_FAIL,
  BUSINESS_UNIT_DETAIL_RESET,
  BUSINESS_UNIT_DETAIL_SUCCESS,
  BUSINESS_UNIT_LIST,
  BUSINESS_UNIT_LIST_COLUMN,
  BUSINESS_UNIT_LIST_FAIL,
  BUSINESS_UNIT_LIST_RESET,
  BUSINESS_UNIT_LIST_SUCCESS,
  BUSINESS_UNIT_ROLE_LIST,
  BUSINESS_UNIT_ROLE_LIST_FAIL,
  BUSINESS_UNIT_ROLE_LIST_RESET,
  BUSINESS_UNIT_ROLE_LIST_SUCCESS,
  BUSINESS_UNIT_UPDATE,
  BUSINESS_UNIT_UPDATE_FAIL,
  BUSINESS_UNIT_UPDATE_RESET,
  BUSINESS_UNIT_UPDATE_SUCCESS,
  DISTRICTS_LIST,
  DISTRICTS_LIST_FAIL,
  DISTRICTS_LIST_SUCCESS,
  GET_IDENTIFICATION_LIST,
  GET_IDENTIFICATION_LIST_FAIL,
  GET_IDENTIFICATION_LIST_SUCCESS,
  LEAVE_DETAIL_BU,
  PROVINCES_LIST,
  PROVINCES_LIST_FAIL,
  PROVINCES_LIST_SUCCESS,
} from "./actionTypes";

// List BusinessUnit
export const listBusinessUnit = (params = {}) => ({
  type: BUSINESS_UNIT_LIST,
  payload: { params },
});

export const listBusinessUnitSuccess = data => ({
  type: BUSINESS_UNIT_LIST_SUCCESS,
  payload: data,
});

export const listBusinessUnitFail = error => ({
  type: BUSINESS_UNIT_LIST_FAIL,
  payload: error,
});

export const resetListBusinessUnit = () => ({
  type: BUSINESS_UNIT_LIST_RESET,
  payload: {},
});

export const setListBusinessUnitColumn = (field, value) => ({
  type: BUSINESS_UNIT_LIST_COLUMN,
  payload: { field, value },
});

// List BusinessUnit Role
export const listBusinessUnitRole = (params = {}) => ({
  type: BUSINESS_UNIT_ROLE_LIST,
  payload: { params },
});

export const listBusinessUnitRoleSuccess = data => ({
  type: BUSINESS_UNIT_ROLE_LIST_SUCCESS,
  payload: data,
});

export const listBusinessUnitRoleFail = error => ({
  type: BUSINESS_UNIT_ROLE_LIST_FAIL,
  payload: error,
});

export const resetListBusinessUnitRole = () => ({
  type: BUSINESS_UNIT_ROLE_LIST_RESET,
  payload: {},
});

// Create BusinessUnit
export const createBusinessUnit = (userCreate, identificationList) => ({
  type: BUSINESS_UNIT_CREATE,
  payload: { userCreate, identificationList },
});

export const createBusinessUnitSuccess = (data, identificationList) => ({
  type: BUSINESS_UNIT_CREATE_SUCCESS,
  payload: { data, identificationList },
});

export const createBusinessUnitFail = error => ({
  type: BUSINESS_UNIT_CREATE_FAIL,
  payload: error,
});

export const resetCreateBusinessUnit = () => ({
  type: BUSINESS_UNIT_CREATE_RESET,
  payload: {},
});

// Detail BusinessUnit
export const detailBusinessUnit = (userId, params = {}) => ({
  type: BUSINESS_UNIT_DETAIL,
  payload: { userId, params },
});

export const detailBusinessUnitSuccess = data => ({
  type: BUSINESS_UNIT_DETAIL_SUCCESS,
  payload: data,
});

export const detailBusinessUnitFail = error => ({
  type: BUSINESS_UNIT_DETAIL_FAIL,
  payload: error,
});

export const resetDetailBusinessUnit = () => ({
  type: BUSINESS_UNIT_DETAIL_RESET,
  payload: {},
});

// Update BusinessUnit
export const updateBusinessUnit = (
  userId,
  data = {},
  identificationList,
  dataRegisTryInvoice,
  bu_code
) => ({
  type: BUSINESS_UNIT_UPDATE,
  payload: { userId, data, identificationList, dataRegisTryInvoice, bu_code },
});

export const updateBusinessUnitSuccess = (data, identificationList) => ({
  type: BUSINESS_UNIT_UPDATE_SUCCESS,
  payload: { data, identificationList },
});

export const updateBusinessUnitFail = error => ({
  type: BUSINESS_UNIT_UPDATE_FAIL,
  payload: error,
});

export const resetUpdateBusinessUnit = () => ({
  type: BUSINESS_UNIT_UPDATE_RESET,
  payload: {},
});

// Delete BusinessUnit
export const deleteBusinessUnit = userId => ({
  type: BUSINESS_UNIT_DELETE,
  payload: { userId },
});

export const deleteBusinessUnitSuccess = data => ({
  type: BUSINESS_UNIT_DELETE_SUCCESS,
  payload: data,
});

export const deleteBusinessUnitFail = error => ({
  type: BUSINESS_UNIT_DELETE_FAIL,
  payload: error,
});

export const resetDeleteBusinessUnit = () => ({
  type: BUSINESS_UNIT_DELETE_RESET,
  payload: {},
});

// Active BusinessUnit
export const activeBusinessUnit = (userId, data = {}) => ({
  type: BUSINESS_UNIT_ACTIVE,
  payload: { userId, data },
});

export const activeBusinessUnitSuccess = data => ({
  type: BUSINESS_UNIT_ACTIVE_SUCCESS,
  payload: data,
});

export const activeBusinessUnitFail = error => ({
  type: BUSINESS_UNIT_ACTIVE_FAIL,
  payload: error,
});

export const resetActiveBusinessUnit = () => ({
  type: BUSINESS_UNIT_ACTIVE_RESET,
  payload: {},
});

//Get list province
export const getListProvince = () => ({
  type: PROVINCES_LIST,
});

export const getListProvinceSuccess = data => ({
  type: PROVINCES_LIST_SUCCESS,
  payload: data,
});

export const getListProvinceFail = error => ({
  type: PROVINCES_LIST_FAIL,
  payload: error,
});

//Get list district
export const getListDistricts = parentId => ({
  type: DISTRICTS_LIST,
  payload: parentId,
});

export const getListDistrictsSuccess = data => ({
  type: DISTRICTS_LIST_SUCCESS,
  payload: data,
});

export const getListDistrictsFail = error => ({
  type: DISTRICTS_LIST_FAIL,
  payload: error,
});

// Detail Config BusinessUnit
export const detailConfigBusinessUnit = (buCode, params = {}) => ({
  type: BUSINESS_UNIT_DETAIL_CONFIG,
  payload: { buCode, params },
});

export const detailConfigBusinessUnitSuccess = data => ({
  type: BUSINESS_UNIT_DETAIL_CONFIG_SUCCESS,
  payload: data,
});

export const detailConfigBusinessUnitFail = error => ({
  type: BUSINESS_UNIT_DETAIL_CONFIG_FAIL,
  payload: error,
});

export const resetConfigDetailBusinessUnit = () => ({
  type: BUSINESS_UNIT_DETAIL_CONFIG_RESET,
  payload: {},
});

// Create BusinessUnit Config
export const createBusinessUnitConfig = data => ({
  type: BUSINESS_UNIT_CONFIG_CREATE,
  payload: { data },
});

export const createBusinessUnitConfigSuccess = data => ({
  type: BUSINESS_UNIT_CONFIG_CREATE_SUCCESS,
  payload: data,
});

export const createBusinessUnitConfigFail = error => ({
  type: BUSINESS_UNIT_CONFIG_CREATE_FAIL,
  payload: error,
});

export const resetCreateBusinessUnitConfig = () => ({
  type: BUSINESS_UNIT_CONFIG_CREATE_RESET,
  payload: {},
});

// Update BusinessUnit Config
export const updateBusinessUnitConfig = (id, data = {}) => ({
  type: BUSINESS_UNIT_CONFIG_UPDATE,
  payload: { id, data },
});

export const updateBusinessUnitConfigSuccess = data => ({
  type: BUSINESS_UNIT_CONFIG_UPDATE_SUCCESS,
  payload: data,
});

export const updateBusinessUnitConfigFail = error => ({
  type: BUSINESS_UNIT_CONFIG_UPDATE_FAIL,
  payload: error,
});

export const resetUpdateBusinessUnitConfig = () => ({
  type: BUSINESS_UNIT_CONFIG_UPDATE_RESET,
  payload: {},
});

// Add identification
export const addIdentification = (data = {}) => ({
  type: ADD_IDENTIFICATION,
  payload: data,
});

export const addIdentificationSuccess = data => ({
  type: ADD_IDENTIFICATION_SUCCESS,
  payload: data,
});

export const addIdentificationFail = error => ({
  type: ADD_IDENTIFICATION_FAIL,
  payload: error,
});

// Get Idenification List by BU code
export const getIdentificationList = buCode => ({
  type: GET_IDENTIFICATION_LIST,
  payload: buCode,
});

export const getIdentificationListSuccess = data => ({
  type: GET_IDENTIFICATION_LIST_SUCCESS,
  payload: data,
});

export const getIdentificationListFail = error => ({
  type: GET_IDENTIFICATION_LIST_FAIL,
  payload: error,
});

// Leave Detail BU
export const leaveDetailBU = () => ({
  type: LEAVE_DETAIL_BU,
});
